import type { Pagination as PaginationT } from '@on3/api';
import { ExpandedPagination } from '@on3/ui-lib/components/Pagination/Expanded/Expanded';
import { SimplePagination } from '@on3/ui-lib/components/Pagination/Simple/Simple';

type PaginationType = 'simple' | 'expanded';

const components = {
  simple: SimplePagination,
  expanded: ExpandedPagination,
};

export const Pagination = ({
  type = 'simple',
  data,
}: {
  type: PaginationType;
  data: PaginationT | undefined;
}) => {
  const Component = components[type];

  if (!Component || !data || data?.pageCount < 2) return null;

  return <Component data={data} />;
};
